/**
 * Loading screen shown during auth initialization
 *
 * OTTO Platform Governance: layout-reference v1
 */

export default function LoadingScreen() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-[#0a0a0a]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-purple-500/30 border-t-purple-400 rounded-full animate-spin" />
        <p className="text-xs text-zinc-600 tracking-wide">Loading Creator Studio...</p>
      </div>
    </div>
  );
}
